export default __webpack_public_path__ + "static/media/marker-rank.ee8a36fa.svg";